import './App.css';
import Discount from './components/Discount';
import Typeface from './components/Typeface';
import LogoSign from './components/LogoSign';
import Phone from './components/Phone';
import LogoMain from './components/LogoMain';
import Billboard from './components/Billboard';
import Slogan from './components/Slogan';
import Bottle from './components/Bottle';

function App() {
  return (
    <div className='container'>
    <div className="bento-container">
      <Discount />
      <Typeface />
      <LogoSign />
      <Phone />
      <LogoMain 
        imagen='dermaskincare'
      />
      <Billboard 
        imagen=''
      />
      <Slogan />
      <Bottle />
    </div>
    </div>
  );
}

export default App;
